import ConsultaBase from "../shared/ConsultaBase";
import { cotherm4comp2ccConsultaConfig } from "../config/cotherm4comp2ccConsulta";

const CCoTherm4Comp2CC = () => {
  return <ConsultaBase config={cotherm4comp2ccConsultaConfig} />;
};

export default CCoTherm4Comp2CC;